/**
 * Billing Store
 * Manages billing modal state (e.g. upgrade modal open)
 */

import { create } from "zustand";
import { devtools } from "zustand/middleware";

export const useBillingStore = create(
  devtools(
    (set) => ({
      showUpgradeModal: false,

      setShowUpgradeModal: (open) => set({ showUpgradeModal: !!open }),
    }),
    { name: "billing-store" },
  ),
);
